// Analytics API helpers — extract real data payloads from each endpoint's wrapper
import { apiFetch } from '../../shared/api/apiClient';

export async function fetchDashboard(): Promise<any> {
  const res = await apiFetch('/api/analytics/kpis');
  if (!res.ok) throw new Error('Failed to load analytics dashboard');
  const body = await res.json();
  return body?.data?.kpis ?? body?.result?.kpis ?? body; // KPIs live at body.data.kpis
}

export async function fetchPayments(): Promise<any> {
  const endDate = new Date().toISOString().split('T')[0];
  const startDate = new Date(Date.now() - 30 * 24 * 60 * 60 * 1000).toISOString().split('T')[0];
  const res = await apiFetch(`/api/analytics/payments?startDate=${startDate}&endDate=${endDate}`);
  if (!res.ok) throw new Error('Failed to load payment analytics');
  const body = await res.json();
  return body?.analytics ?? body; // payments analytics live at body.analytics
}

export async function fetchSubscriptions(): Promise<any> {
  const res = await apiFetch('/api/analytics/subscriptions');
  if (!res.ok) throw new Error('Failed to load subscription analytics');
  const body = await res.json();
  return body?.analytics ?? body; // subscription analytics live at body.analytics
}

export async function fetchRevenue(): Promise<any> {
  const endDate = new Date().toISOString().split('T')[0];
  const startDate = new Date(Date.now() - 30 * 24 * 60 * 60 * 1000).toISOString().split('T')[0];
  const res = await apiFetch(`/api/analytics/payments?startDate=${startDate}&endDate=${endDate}`);
  if (!res.ok) throw new Error('Failed to load revenue analytics');
  const body = await res.json();
  return body?.analytics ?? body; // revenue reuses payment analytics endpoint
}

export default { fetchDashboard, fetchPayments, fetchSubscriptions, fetchRevenue };
